import { IOperation } from './i-operation';
import { Connection } from '@3d-scene/model3d/connection';
import { LoadConnectionTextureProcessor } from '@3d-scene/processor/load-connection-texture.processor';
import { BaseImageConnectionsOperation } from './base-image-connections-operation';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LabelingUtils } from '@3d-scene/model3d/util/labeling-utils';

export class UndoRemoveImageConnectionsOperation extends BaseImageConnectionsOperation implements IOperation {
  constructor(
    connectionCubes: Connection[],
    loadTextureProcessor: LoadConnectionTextureProcessor,
    containerService: ContainerService,
    labelingUtils: LabelingUtils,
  ) {
    super(connectionCubes, loadTextureProcessor, containerService, labelingUtils);
  }

  public getQualifiedClassName(): string {
    return 'UndoRemoveImageConnectionsOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    super.removeImages();
  }

  public async performUndo(): Promise<void> {
    super.restoreImages(false);
  }
}
